'use client'

import { shareInfoTypes } from "@/app/livebroadcast/_config"
import { webShare } from "@/util/webShare"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { ReactNode, useContext, useEffect, useRef } from "react"

import meta from "@/meta/metadata.json"
import { AuthContext } from "./authContext"
import { SignContext } from "./signContext"
import customAlert from "@/util/customAlert"
import { setCookie } from "@/util/cookie"
import { useTranslations } from "next-intl"

export default function ParamsProviders({ children }: { children: ReactNode }) {
    const { user, loading } = useContext(AuthContext)
    const { SetSignUpShow } = useContext(SignContext)

    const searchParam = useSearchParams()
    const pathName = usePathname()
    const router = useRouter()

    const t = useTranslations("Text")

    function shareEventHandlr() {
        const data = meta['main'];
        const shareInfo = {

            url: `${window.location.protocol}//${window.location.host}`,
            title: data.title,
            description: data.description,
        }
        webShare(shareInfo)
        router.push(pathName)
    }

    useEffect(() => {
        // 공유하기
        const shareParams = searchParam.get('script')
        if (shareParams == 'share') {
            customAlert(t("스폰TV 공유하기"), 'success', () => { shareEventHandlr(); }, { didClose: () => { shareEventHandlr(); } })
        }
    }, [searchParam])
    useEffect(() => {
        // 가입코드
        const recomenderCode = searchParam.get('code')
        if (recomenderCode) {

            const expireDate = new Date();
            expireDate.setHours(expireDate.getHours() + 1); // ⏱ 1시간 뒤

            console.log("code expire: ", expireDate)

            setCookie('code', recomenderCode, {
                path: '/',
                // expires: expireDate,
            });
        }
    }, [searchParam])

    useEffect(() => {
        // 회원가입
        if (loading) return;
        if (user.is_authenticated) return;

        const shareParams = searchParam.get('script')
        if (shareParams == 'signin') {
            setTimeout(() => {
                SetSignUpShow(true)
                router.push(pathName)
            }, 200)
        }
    }, [searchParam, loading])

    return (children)
}